
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/privacy-policy",
      function () {
        return require("private-next-pages/[lang]/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/privacy-policy"])
      });
    }
  